import React from "react"
import PropTypes from "prop-types"


import LoaderSection from '../app_components/LoaderSection'
import Icon from '../app_components/Icon'
import StandardButton from '../app_components/StandardButton'
import { semantic } from '@lexody/design-tokens'
import DashMoreToDoSection from './DashMoreToDo'
import ProfileBadgeSection from '../gamification_components/ProfileBadgeSection'
import UpcomingMeetingSection from '../profile_sections/UpcomingMeetingSection'
import UserGamificationDashboard from './UserGamificationDashboard'
import DashboardRewardAlerts from './DashboardRewardAlerts'


class MemberDashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentUser: [],
      notifications: [],
      dataLoaded: false,
      lexes: 0,
      width: 0,
      accountUnpaused: false,
      blogPosts: [],
      suggestedBooks: [],
      notificationRefreshTrigger: 0,
    }
    this.renderUnpauseAccount = this.renderUnpauseAccount.bind(this)
    this.unpauseAccount = this.unpauseAccount.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.loadUserData = this.loadUserData.bind(this)
    this.handleRewardAlertDismissed = this.handleRewardAlertDismissed.bind(this)
  }

  handleRewardAlertDismissed() {
    this.setState((prev) => ({
      notificationRefreshTrigger: prev.notificationRefreshTrigger + 1,
    }))
  }

  updateDimensions() {
    this.setState({
      width: window.innerWidth
    })
  }

  loadUserData() {
    $.ajax({
      url: `../getUserData`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          currentUser: JSON.parse(data.data.current_user),
          notifications: JSON.parse(data.data.notifications),
          dataLoaded: true,
          lexes: data.data.lexes,
          languages: JSON.parse(data.data.learning_languages),
          blogPosts: JSON.parse(data.data.blog_posts),
          suggestedBooks: JSON.parse(data.data.suggested_books)
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
    this.loadUserData();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  unpauseAccount() {
    this.setState({
      accountUnpaused: true
    })
    let data = {
      user: {
        status: 'Active'
      }
    }
    $.ajax({
      url: `../updateUser`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {

      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    })
  }

  renderUnpauseAccount() {
    if (this.state.accountUnpaused) {
      return (
        <section className="dashboard-pause-banner dashboard-pause-banner--active" aria-live="polite">
          <div className="dashboard-pause-banner__iconCircle dashboard-pause-banner__iconCircle--success" aria-hidden="true">
            <Icon
              name="check-circle"
              size={22}
              color={semantic.primary.surface.default}
            />
          </div>
          <h3 className="dashboard-pause-banner__title dashboard-pause-banner__title--centered">
            Welcome back!
          </h3>
          <p className="dashboard-pause-banner__body dashboard-pause-banner__body--centered">
            Your account is fully active again. Ready to find your next language partner?
          </p>
          <StandardButton
            text="See my matches"
            primary
            fullWidth
            onClick={() => window.location.assign('/friends')}
          />
        </section>
      )
    }

    return (
      <section className="dashboard-pause-banner" aria-labelledby="dashboard-pause-heading">
        <div className="dashboard-pause-banner__header">
          <div className="dashboard-pause-banner__iconCircle" aria-hidden="true">
            <Icon
              name="hourglass"
              size={22}
              color={semantic.primary.surface.default}
            />
          </div>
          <div className="dashboard-pause-banner__headingGroup">
            <p className="dashboard-pause-banner__eyebrow">Account paused</p>
            <h3 className="dashboard-pause-banner__title" id="dashboard-pause-heading">
              You&apos;re on a break
            </h3>
          </div>
        </div>
        <p className="dashboard-pause-banner__body">
          Your profile is hidden from matches and you won&apos;t receive updates from Lexody.
          When you&apos;re ready, reactivate to start connecting again.
        </p>
        <StandardButton
          text="Reactivate account"
          primary
          fullWidth
          onClick={() => this.unpauseAccount()}
        />
        <p className="dashboard-pause-banner__footnote">
          You can pause again anytime from Settings.
        </p>
      </section>
    )
  }
  //<WeeklyWritingPrompt lexicoin={this.props.lexicoin}/>


  render() {
    if(this.state.dataLoaded) {
      return(
        <div className="memberDashboardContent">
              <DashboardRewardAlerts
                confettiLottie={this.props.confettiLottie}
                lexicoin={this.props.lexicoin}
                userId={this.state.currentUser.id}
                onDismissed={this.handleRewardAlertDismissed}
                refreshTrigger={this.state.notificationRefreshTrigger}
              />
              <div className="userGamificationDashboard">
                {this.state.currentUser.status === "Travelling" &&
                  this.renderUnpauseAccount()
                }
                <UserGamificationDashboard
                  currentUser={this.state.currentUser}
                  lexicoin={this.props.lexicoin}
                  connectCoin={this.props.connectCoin}
                  lexes={this.state.lexes}
                  missingImg={this.props.missingImg}
                  confettiLottie={this.props.confettiLottie}
                  closeIcon={this.props.closeIcon}
                  notificationRefreshTrigger={this.state.notificationRefreshTrigger}
                />
              </div>
              <div className="upcomingMeetingSection">
                <UpcomingMeetingSection
                  image_loader={this.props.image_loader}
                  missingImg={this.props.missingImg}
                  currentUser={this.state.currentUser}
                  />
              </div>
              <ProfileBadgeSection
                userId={this.state.currentUser.id}
                dashboard={true}
                closeIcon={this.props.closeIcon}
                width={this.state.width}
                image_loader={this.props.image_loader}
              />
              <DashMoreToDoSection
                width={this.state.width}
                languages={this.state.languages}
                writingIcon={this.props.writingIcon}
                blogPosts={this.state.blogPosts}
                suggestedBooks={this.state.suggestedBooks}
                blogAccentImage={this.props.blogAccentImage}
                readingAccentImage={this.props.readingAccentImage}
              />

        </div>
      )
    }
    return <LoaderSection/>
  }
}

export default MemberDashboard;
